import Axios from 'axios'
import store from '../store'
import strings from '@/strings'

const site = {
  getClientId () {
    return store.getters['Client/clientId']
  },
  getSites () {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/sites`)
  },
  getActiveSites () {
    return Axios.get(`api/${strings.apiVersion.public}/clients/${this.getClientId()}/sites`)
  },
  addSite (site) {
    return Axios.post(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/sites`, site)
  },
  editSite (site) {
    return Axios.put(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/sites/${site.id}`, site)
  },
  inheritSettings (site) {
    return Axios.put(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/sites/${site.id}/configs/inherit-global`, site)
  },
  activateSite (siteId) {
    return Axios.patch(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/sites/${siteId}/activate`)
  },
  deactivateSite (siteId) {
    return Axios.patch(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/sites/${siteId}/deactivate`)
  }
}

export default site
